// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2NXbe","legacyBtn":"MutateMid_legacyBtn__1Dszv"};